import { render, staticRenderFns } from "./zxFooter.vue?vue&type=template&id=1fc6b103&scoped=true"
import script from "./zxFooter.vue?vue&type=script&lang=js"
export * from "./zxFooter.vue?vue&type=script&lang=js"
import style0 from "./zxFooter.vue?vue&type=style&index=0&id=1fc6b103&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc6b103",
  null
  
)

export default component.exports